import type { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { Container } from '~/components/ui/Container'
import { Layout } from '~/layouts/default'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { SEOHead } from '~/components/business/SEOHead'
import { SinglePresale } from '~/components/business/SinglePresale'
import { GET_PRESALE_ACTIVITY_LIST } from '~/graphqls/gqls'
import {
  presaleActivityList,
  presaleActivityListVariables,
  presaleActivityList_marketingModule_crowdfundingActivityHomePage_edges_node,
} from '~/graphqls/types'
import { getGraphData } from '~/utils'
import { MyEmpty } from '~/components/ui/MyEmpty'
import { serverSideCatch } from '~/utils'
import { PAGE_SIZE } from '~/configs'
import useInfiniteScroll from '~/hooks/useInfiniteScroll'

const Presale: NextPage<{
  presaleData: presaleActivityList_marketingModule_crowdfundingActivityHomePage_edges_node[]
  hasNext: boolean
}> = ({ presaleData, hasNext = false }) => {
  const { list: renderList, InfiniteScollComp: SearchInfiniteScroll } =
    useInfiniteScroll<
      presaleActivityList_marketingModule_crowdfundingActivityHomePage_edges_node,
      presaleActivityList,
      presaleActivityListVariables
    >({
      queryDoc: GET_PRESALE_ACTIVITY_LIST,
      initData: presaleData,
      hasNextPage: hasNext,
      hasNextPageExtractor: data => {
        return (
          data?.data?.marketingModule?.crowdfundingActivityHomePage?.pageInfo
            ?.hasNextPage || false
        )
      },
      dataExtractor: data => {
        return getGraphData(
          data?.data?.marketingModule?.crowdfundingActivityHomePage?.edges || []
        )
      },
    })
  return (
    <Layout>
      <SEOHead title="预售活动" />
      <Container>
        <PageCrumbs title="预售活动" hasBack />
        <div>
          {renderList?.length ? (
            renderList?.map(it => {
              return (
                <div className="mb-8 rounded-2xl overflow-hidden" key={it.id}>
                  <SinglePresale data={it} />
                </div>
              )
            })
          ) : (
            <MyEmpty />
          )}
          {SearchInfiniteScroll}
        </div>
      </Container>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await serverSideCatch(async () => {
    const { initialState, client } = await GlobalRequest(context)
    try {
      const presaleRes = await client.query<
        presaleActivityList,
        presaleActivityListVariables
      >({
        query: GET_PRESALE_ACTIVITY_LIST,
        variables: {
          first: PAGE_SIZE,
          offset: 0,
        },
        fetchPolicy: 'no-cache',
      })

      return {
        props: {
          initialState,
          presaleData: getGraphData(
            presaleRes?.data?.marketingModule?.crowdfundingActivityHomePage
              ?.edges || []
          ),
          hasNext:
            presaleRes?.data?.marketingModule?.crowdfundingActivityHomePage
              ?.pageInfo?.hasNextPage || false,
        },
      }
    } catch (error) {
      return {
        props: {
          initialState,
          presaleData: [],
          hasNext: false,
        },
      }
    }
  })
}

export default Presale
